import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedMicrophone: null,
  selectedSpeaker: null,
};

const audioDeviceSlice = createSlice({
  name: 'audioDevice',
  initialState,
  reducers: {
    setSelectedMicrophone: (state, action) => {
      state.selectedMicrophone = action.payload;
    },
    setSelectedSpeaker: (state, action) => {
      state.selectedSpeaker = action.payload;
    },
  },
});

export const { setSelectedMicrophone, setSelectedSpeaker } = audioDeviceSlice.actions;

export const selectSelectedMicrophone = (state) => state.audioDevice.selectedMicrophone;
export const selectSelectedSpeaker = (state) => state.audioDevice.selectedSpeaker;

export default audioDeviceSlice.reducer;
